import Tooltip from '@repo/editor/src/components/Tooltip/Tooltip';
import {
  TooltipAlignment,
  TooltipPlacement,
} from '@repo/editor/src/components/Tooltip/types';
import { withEventScope } from '@repo/event-processor';
import { Button } from '@repo/ui/components/Buttons';
import ThumbsUpIcon from '@repo/ui/components/Icon/ThumbsUpIcon';
import { themeStyle } from '@repo/ui/theming';

import ChallengeBadge from 'components/Challenges/ChallengeBadge/ChallengeBadge';

import {
  ChallengeWrapper,
  ChallengeInfoWrapper,
  ChallengePositionInfo,
} from './styles';
import { alreadyVotedTheme, notVotedTheme } from './theme';
import { ChallengeInfoProps } from './types';

const ChallengeInfo = ({
  post,
  small,
  onUpvote,
  upvotedByUser,
}: ChallengeInfoProps) => {
  const notVotedNewTheme = {
    ...notVotedTheme,
    iconActiveColor: themeStyle.varBlueMedium,
  };

  return (
    <ChallengeWrapper small={small} upvotedByUser={upvotedByUser}>
      <Tooltip
        align={TooltipAlignment.Start}
        placement={TooltipPlacement.Bottom}
        text={post.challenge?.name}
      >
        <ChallengeInfoWrapper href={`/challenges/${post.challenge?.slug}`}>
          <ChallengeBadge
            height={small ? '24px' : '32px'}
            position={post.challengePosition}
          />
          {post.challengePosition && (
            <ChallengePositionInfo>
              {{
                1: 'Design Challenge Winner',
                2: 'Design Challenge 2nd Place',
                3: 'Design Challenge 3rd Place',
              }[post.challengePosition] || 'Design Challenge Submission'}
            </ChallengePositionInfo>
          )}
        </ChallengeInfoWrapper>
      </Tooltip>
      {!post.challengePosition && (
        <Button
          isCentered
          height="40px"
          icon={{ component: ThumbsUpIcon, height: '16px' }}
          label={upvotedByUser ? 'Already Voted' : 'Upvote Design'}
          name="upvoteDesignButton"
          theme={upvotedByUser ? alreadyVotedTheme : notVotedNewTheme}
          width="100%"
          onClick={onUpvote}
        />
      )}
    </ChallengeWrapper>
  );
};

export default withEventScope(ChallengeInfo, { module: 'challengeInfo' });
